import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "file-list"
};
const _hoisted_2 = {
  class: "grid-content"
};
const _hoisted_3 = {
  class: "grid-content"
};
const _hoisted_4 = {
  class: "opt"
};
import { reactive, ref } from "vue";
import { ElMessage } from "element-plus";
import { httpGet, httpPost } from "@/utils/http";
import { Delete, Plus } from "@element-plus/icons-vue";
import { isImage, removeArrayItem } from "@/utils/libs";
import { GetFileIcon } from "@/store/system";
import { checkSession } from "@/store/cache";
import { useSharedStore } from "@/store/sharedata";
export default {
  __name: 'FileSelect',
  props: {
    userId: Number
  },
  emits: ["selected"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const show = ref(false);
    const scrollbarRef = ref(null);
    const fileData = reactive({
      items: [],
      page: 1,
      isLastPage: true
    });
    const store = useSharedStore();
    const fetchFiles = pageNo => {
      checkSession().then(() => {
        show.value = true;
        httpPost("/upload/list", {
          page: pageNo || 1,
          page_size: 30
        }).then(res => {
          const {
            items,
            page,
            total_page
          } = res.data;
          if (page === 1) {
            fileData.items = items;
          } else {
            fileData.items = [...fileData.items, ...items];
          }
          fileData.isLastPage = page === total_page;
          if (!fileData.isLastPage) {
            fileData.page = page + 1;
          }
        }).catch(e => {
          showMessageError("获取文件列表失败：" + e.message);
        });
      }).catch(() => {
        store.setShowLoginDialog(true);
      });
    };

    // el-scrollbar 滚动回调
    const onScroll = options => {
      const wrapRef = scrollbarRef.value.wrapRef;
      scrollbarRef.value.moveY = wrapRef.scrollTop * 100 / wrapRef.clientHeight;
      scrollbarRef.value.moveX = wrapRef.scrollLeft * 100 / wrapRef.clientWidth;
      const poor = wrapRef.scrollHeight - wrapRef.clientHeight;
      // 判断滚动到底部 自动加载数据
      if (options.scrollTop + 2 >= poor && !fileData.isLastPage) {
        fetchFiles(fileData.page);
      }
    };
    const afterRead = file => {
      const formData = new FormData();
      formData.append("file", file.file, file.name);
      // 执行上传操作
      httpPost("/upload", formData).then(res => {
        fileData.items.unshift(res.data);
        ElMessage.success({
          message: "上传成功",
          duration: 500
        });
      }).catch(e => {
        ElMessage.error("图片上传失败:" + e.message);
      });
    };
    const removeFile = file => {
      httpGet("/upload/remove?id=" + file.id).then(() => {
        fileData.items = removeArrayItem(fileData.items, file, (v1, v2) => {
          return v1.id === v2.id;
        });
        ElMessage.success("文件删除成功！");
        fetchFiles(1);
      }).catch(e => {
        ElMessage.error("文件删除失败:" + e.message);
      });
    };
    const insertURL = file => {
      show.value = false;
      // 如果是相对路径，处理成绝对路径
      if (file.url.indexOf("http") === -1) {
        file.url = location.protocol + "//" + location.host + file.url;
      }
      emits("selected", file);
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createBlock(_component_el_container, {
        class: "file-select-box"
      }, {
        default: _withCtx(() => [_createElementVNode("a", {
          class: "file-upload-img",
          onClick: _cache[0] || (_cache[0] = $event => fetchFiles(1))
        }, _cache[3] || (_cache[3] = [_createElementVNode("i", {
          class: "iconfont icon-attachment-st"
        }, null, -1)])), _createVNode(_component_el_dialog, {
          class: "file-list-dialog",
          modelValue: show.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => show.value = $event),
          "close-on-click-modal": true,
          "show-close": true,
          width: 800,
          title: "文件管理"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
            ref_key: "scrollbarRef",
            ref: scrollbarRef,
            "max-height": "80vh",
            style: {
              "height": "100%"
            },
            onScroll: onScroll
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
              gutter: 20
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 3
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_upload, {
                  class: "avatar-uploader",
                  "auto-upload": true,
                  "show-file-list": false,
                  "http-request": afterRead,
                  accept: ".doc,.docx,.jpg,.png,.jpeg,.xls,.xlsx,.ppt,.pptx,.pdf,.mp4,.mp3"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, {
                    class: "avatar-uploader-icon"
                  }, {
                    default: _withCtx(() => [_createVNode(_unref(Plus))]),
                    _: 1
                  })]),
                  _: 1
                })])]),
                _: 1
              }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileData.items, file => {
                return _openBlock(), _createBlock(_component_el_col, {
                  span: 3,
                  key: file.url
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_tooltip, {
                    class: "box-item",
                    effect: "dark",
                    content: file.name,
                    placement: "top"
                  }, {
                    default: _withCtx(() => [_unref(isImage)(file.ext) ? (_openBlock(), _createBlock(_component_el_image, {
                      key: 0,
                      src: file.url,
                      fit: "cover",
                      onClick: $event => insertURL(file)
                    }, null, 8, ["src", "onClick"])) : (_openBlock(), _createBlock(_component_el_image, {
                      key: 1,
                      src: _unref(GetFileIcon)(file.ext),
                      fit: "cover",
                      onClick: $event => insertURL(file)
                    }, null, 8, ["src", "onClick"]))]),
                    _: 2
                  }, 1032, ["content"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
                    type: "danger",
                    size: "small",
                    icon: _unref(Delete),
                    onClick: $event => removeFile(file),
                    circle: ""
                  }, null, 8, ["icon", "onClick"])])])]),
                  _: 2
                }, 1024);
              }), 128))]),
              _: 1
            }), !fileData.isLastPage ? (_openBlock(), _createBlock(_component_el_row, {
              key: 0,
              justify: "center",
              onClick: _cache[1] || (_cache[1] = $event => fetchFiles(fileData.page))
            }, {
              default: _withCtx(() => [_createVNode(_component_el_link, null, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("加载更多")])),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true)])]),
            _: 1
          }, 512)]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      });
    };
  }
};